export const Line = () => {
  return <hr className="line mt-4 mb-4"/>
};